const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: "cart-update",
  quantityUpdate: "quantity-update",
  optionValueSelectionChange: "option-value-selection-change",
  variantChange: "variant-change",
  cartError: "cart-error",
  contentAdded: "content-added",
  menuReady: "menu-ready",
  closeOpenPopup: "close-open-popup",
  cartToggle: "cart-toggle",
  cartItemRemove: "cart-item-remove",
  cartItemQuantity: "cart-item-quantity",
  
};
